import { useCallback, useMemo } from "react";
import { useGridFilter } from "ag-grid-react";
import type { CustomFilterProps } from "ag-grid-react";
import { PasswordStatusOptions } from "./utils";

const OPTIONS = [
  PasswordStatusOptions.CONFIRMED,
  PasswordStatusOptions.TEMP_PASSWORD,
  PasswordStatusOptions.SSO_ONLY,
] as const;

type Model = { values: string[] } | null;

export const PasswordStatusFilter = ({
  model,
  onModelChange,
  getValue,
}: CustomFilterProps<unknown, unknown, Model>) => {
  const selected = useMemo(
    () => (model ? new Set(model.values) : new Set(OPTIONS)),
    [model],
  );

  useGridFilter({
    doesFilterPass: (params) => selected.has(getValue(params.node) ?? ""),
  });

  const toggle = useCallback(
    (option: string) => {
      const next = new Set(selected);
      if (next.has(option)) {
        next.delete(option);
      } else {
        next.add(option);
      }
      onModelChange(
        next.size === OPTIONS.length ? null : { values: Array.from(next) },
      );
    },
    [selected, onModelChange],
  );

  return (
    <div
      style={{
        padding: "8px",
        display: "flex",
        flexDirection: "column",
        gap: "6px",
      }}
    >
      {OPTIONS.map((option) => (
        <label
          key={option}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
          }}
        >
          <input
            type="checkbox"
            checked={selected.has(option)}
            onChange={() => toggle(option)}
          />
          {option}
        </label>
      ))}
    </div>
  );
};
